import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";
import {ObjectIdentifier} from "../../../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../../../core/shared/basic/object-identifier-data";
import {
    MvsObjectNavigationService
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationEntry
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


@Component({
    selector: 'ei-import-type-structures-component',
    templateUrl: 'ei-import-type-structures.component.html',
    standalone: false
})
export class EiImportTypeStructuresComponent implements OnInit, OnChanges {

    @Input() importTypeId: number;

    initialized: boolean;
    structuresWidget: WidgetData;

    private builtForId: number;

    constructor(protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.importTypeId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.structuresWidget && this.builtForId === this.importTypeId) {
            return;
        }

        this.structuresWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'ei.importType.structures.widget',
            'Strukturen',
            'ei.EiStructure',
            [FilterCriteria.create('e.importTypeId', FilterCriteria.cOperatorEqual, this.importTypeId)],
            []
        );

        // FK defaulting on create (CONFIG-012)
        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'importTypeDtoId', fieldValue: this.importTypeId}
        ];
        this.structuresWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
        this.builtForId = this.importTypeId;
    }

    onStructureSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        if (!event?.objectId) {
            return;
        }
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'ei.EiStructure',
            event.objectId,
            'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
